var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sui-message',{staticStyle:{"margin-top":"2em"},attrs:{"info":""}},[_c('p',[_c('font-awesome-icon',{attrs:{"icon":"info-circle"}}),_vm._v(" No "+_vm._s(_vm.resourceName)+" resources found to be listed. Please try again after the resources have been added. ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }